import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
import { Shield, Award, CheckCircle2 } from 'lucide-react';
export function PricingCards() {
  return <section id="pricing" className="py-12 md:py-20 px-4 bg-brand-light relative" data-id="element-190">
      <div className="max-w-4xl mx-auto" data-id="element-191">
        {/* Urgency Section */}
        <div className="text-center mb-12" data-id="element-192">
          <div className="inline-block bg-red-900/40 border border-red-500/30 rounded-2xl p-6 md:p-8 shadow-lg mb-8" data-id="element-193">
            <h3 className="text-red-400 font-bold tracking-widest uppercase mb-6 flex items-center justify-center gap-2" data-id="element-194">
              <span className="animate-pulse" data-id="element-195">⏰</span> PRECIO DE LANZAMIENTO —
              OFERTA LIMITADA
            </h3>
            <CountdownTimer data-id="element-196" />
            <p className="text-cream/90 mt-6 font-medium flex items-center justify-center gap-2" data-id="element-197">
              <span className="text-red-400" data-id="element-198">⚠️</span> Después sube $300 UYU. No
              vuelve.
            </p>
          </div>

          <div className="max-w-md mx-auto bg-brand-dark border border-gold/20 rounded-xl p-4" data-id="element-199">
            <p className="text-red-400 text-sm font-bold flex items-center gap-2 mb-2" data-id="element-200">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-201" />
              Cupos al precio de lanzamiento — Quedan pocos
            </p>
            <div className="w-full bg-brand-green rounded-full h-3 mb-2 overflow-hidden border border-gold/10" data-id="element-202">
              <div className="bg-gold-gradient h-full rounded-full w-[68%]" data-id="element-203" />
            </div>
            <p className="text-cream/70 text-xs text-right" data-id="element-204">
              68% de los cupos ya tomados
            </p>
          </div>
        </div>

        <div className="text-center mb-10" data-id="element-205">
          <h2 className="text-3xl md:text-4xl font-black text-white" data-id="element-206">
            Elegí Tu Pack
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto items-center" data-id="element-207">
          {/* Card A: Basic */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-dark border border-gold/20 rounded-2xl p-6 md:p-8 flex flex-col h-full" data-id="element-208">
            <div className="mb-6" data-id="element-209">
              <BookIcon className="w-8 h-8 text-gold mb-4" data-id="element-210" />
              <h3 className="text-xl font-black text-white mb-2" data-id="element-211">
                SISTEMA LIBRE DE CLEARING
              </h3>
              <p className="text-gold font-bold text-sm mb-4" data-id="element-212">
                6 Tomos + 6 Bonos — Pack Completo
              </p>
              <div className="bg-brand-green/50 rounded-lg p-3 text-sm text-cream/80" data-id="element-213">
                <span className="font-bold text-white" data-id="element-214">Ideal para:</span>{' '}
                Cualquier persona con registros negativos en Uruguay — deudas
                propias, caducadas o activas
              </div>
            </div>

            <div className="border-t border-gold/10 pt-6 mb-6 flex-1" data-id="element-215">
              <p className="text-red-400 line-through text-lg text-center mb-1" data-id="element-216">
                ~~$8,370 UYU~~
              </p>
              <p className="text-4xl md:text-5xl font-black text-gold-gradient text-center mb-2" data-id="element-217">
                $690 <span className="text-xl md:text-2xl" data-id="element-218">UYU</span>
              </p>
            </div>

            <CTAButton href="https://www.avanzapro.store/cart/48352083116257:1" className="mt-auto" data-id="element-219">
              → QUIERO MI MEGAPACK SISTEMA LIBRE DE CLEARING
            </CTAButton>
          </motion.div>

          {/* Card B: PRO */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-brand-dark to-brand-green border-2 border-gold rounded-2xl p-6 md:p-8 flex flex-col h-full relative shadow-gold-glow-lg md:scale-105 z-10" data-id="element-220">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-brand-dark font-black px-6 py-1 rounded-full text-sm flex items-center gap-2 shadow-lg whitespace-nowrap" data-id="element-221">
              <Award className="w-4 h-4" data-id="element-222" /> ⭐ MÁS POPULAR ⭐
            </div>

            <div className="mb-6 mt-4" data-id="element-223">
              <Shield className="w-8 h-8 text-gold mb-4" data-id="element-224" />
              <h3 className="text-xl font-black text-white mb-2" data-id="element-225">
                SISTEMA LIBRE DE CLEARING <br data-id="element-226" />
                <span className="text-gold" data-id="element-227">+ BLINDAJE PRO</span>
              </h3>
              <p className="text-gold font-bold text-sm mb-4" data-id="element-228">
                6 Tomos + 6 Bonos + Método PRO Blindaje Financiero Total
              </p>
              <div className="bg-brand-dark/50 rounded-lg p-3 text-sm text-cream/80" data-id="element-229">
                <span className="font-bold text-white" data-id="element-230">Ideal para:</span> Quien
                no solo quiere salir del Clearing sino asegurarse de NUNCA MÁS
                volver a entrar
              </div>
            </div>

            <div className="border-t border-gold/20 pt-6 mb-6 flex-1" data-id="element-231">
              <p className="text-red-400 line-through text-lg text-center mb-1" data-id="element-232">
                ~~$9,870 UYU~~
              </p>
              <p className="text-5xl md:text-6xl font-black text-gold-gradient text-center mb-2" data-id="element-233">
                $990 <span className="text-xl md:text-2xl" data-id="element-234">UYU</span>
              </p>
            </div>

            <CTAButton href="https://www.avanzapro.store/cart/48352082264289:1" className="mt-auto" data-id="element-235">
              → QUIERO EL MEGAPACK + CONTENIDO EXTRA
            </CTAButton>
          </motion.div>
        </div>
      </div>
    </section>;
}
function BookIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-236">
      <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" data-id="element-237" />
    </svg>;
}